import moment from "moment";
export const formatDurationWithLabel = (seconds = 0) => {
  const duration = moment.duration(seconds, "seconds");
  
  if (duration.asYears() >= 1) {
    const years = Math.floor(duration.asYears());
    const days = Math.floor(duration.subtract(years, "years").asDays());
    return {
      value: `${years}y ${days}d`,
      label: "YY:DD"
    };
  }
  
  if (duration.asDays() >= 1) {
    const days = Math.floor(duration.asDays());
    const hours = Math.floor(duration.subtract(days, "days").asHours());
    return {
      value: `${days}d ${hours}h`,
      label: "DD:HH"
    };
  }
  
  if (duration.asHours() >= 1) {
    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.subtract(hours, "hours").asMinutes());
    return {
      value: `${hours}h ${minutes}m`,
      label: "HH:MM"
    };
  }
  
  const minutes = Math.floor(duration.asMinutes());
  const remainingSeconds = Math.floor(duration.subtract(minutes, "minutes").asSeconds());
  return {
    value: `${minutes}m ${remainingSeconds}s`,
    label: "MM:SS"
  };
};

export function safeDivide(a, b, fallback = 0) {
  if (b === 0) return fallback;
  const result = a / b;
  return Number.isFinite(result) ? result : fallback;
}

export function formatNumber(value, decimals = 2, fallback = '-') {
  if (!value && value !== 0) return fallback;
  if (Number.isInteger(value)) {
    return value;
  }
  return Number(value).toFixed(decimals);
}